var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMotor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 86,
    viewBox: "0 0 71 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 0V86H70.5V0H69.5Z",
    fill: "#E6E6E6",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 40.75L14.625 30.625H39.375L42.75 40.75M39.375 52C38.4799 52 37.6215 51.6444 36.9885 51.0115C36.3556 50.3786 36 49.5201 36 48.625C36 47.7299 36.3556 46.8714 36.9885 46.2385C37.6215 45.6056 38.4799 45.25 39.375 45.25C40.2701 45.25 41.1285 45.6056 41.7615 46.2385C42.3944 46.8714 42.75 47.7299 42.75 48.625C42.75 49.5201 42.3944 50.3786 41.7615 51.0115C41.1285 51.6444 40.2701 52 39.375 52ZM14.625 52C13.7299 52 12.8714 51.6444 12.2385 51.0115C11.6056 50.3786 11.25 49.5201 11.25 48.625C11.25 47.7299 11.6056 46.8714 12.2385 46.2385C12.8714 45.6056 13.7299 45.25 14.625 45.25C15.5201 45.25 16.3786 45.6056 17.0115 46.2385C17.6444 46.8714 18 47.7299 18 48.625C18 49.5201 17.6444 50.3786 17.0115 51.0115C16.3786 51.6444 15.5201 52 14.625 52ZM42.57 29.5C42.12 28.195 40.86 27.25 39.375 27.25H14.625C13.14 27.25 11.88 28.195 11.43 29.5L6.75 43V61C6.75 61.5967 6.98705 62.169 7.40901 62.591C7.83097 63.0129 8.40326 63.25 9 63.25H11.25C11.8467 63.25 12.419 63.0129 12.841 62.591C13.2629 62.169 13.5 61.5967 13.5 61V58.75H40.5V61C40.5 61.5967 40.7371 62.169 41.159 62.591C41.581 63.0129 42.1533 63.25 42.75 63.25H45C45.5967 63.25 46.169 63.0129 46.591 62.591C47.0129 62.169 47.25 61.5967 47.25 61V43L42.57 29.5Z",
    fill: "url(#paint0_linear_2645_7488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2645_7488",
    x1: 6.75,
    y1: 46.5651,
    x2: 47.6303,
    y2: 46.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#880000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotor);
export default __webpack_public_path__ + "static/media/Motor.2e7574c24b4bedd633fc7703b2f3b988.svg";
export { ForwardRef as ReactComponent };